import React from 'react';

import fetch from '../../fetch';

import utils from '../../../utils';

const prefixUrl = "graduation/course/signup/view/"

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const columns = utils.columns(
    [
        {   
            key:'$index', 
            label: '序号',
            width: 80
        },
        {
            key: 'orgName',
            label: '所属部门',
            width: 100
        },
        {
            key:'courseName', 
            label: '课程名称',
            width: 100
        },
        {
            key: 'majorName',
            label: '开课专业',
            width: 100
        },
        {
            key: 'coursePropertiesName', 
            label: '课程性质',
            width: 100
        },
        {
            key: 'courseTypeName', 
            label: '课程类型',
            width: 100
        },
        {
            key: 'studyTime', 
            label: '学时',
            width: 80
        },
        {
            key: 'certifiedTeacherCode', 
            label: '认证教师工号',
            width: 120
        },
        {
            key: 'certifiedTeacherName', 
            label: '认证教师',
            width: 100
        },
        {
            key: 'mentorCode', 
            label: '指导教师工号',
            width: 120
        },
        {
            key: 'mentorName', 
            label: '指导教师',
            width: 100
        },
        {
            key: 'guidanceGroup', 
            label: '指导群',
            width: 100
        },
        {
            key: 'batchNo', 
            label: '批次',
            width: 100
        },
        {
            key: 'termName', 
            label: '所属学期',
            width: 100
        }
    ]
)

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post(`${prefixUrl}query?` + params.join('&'), keywords)
    .then(response => {
        if (response.code === 200) {
            return {
                data: response.payload.data,
            }
        }
    })
    .then(res => (
        Object.assign({
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data.dataList || []).length ? '' : '暂无数据...'
        }))
    )
}

const removeByIds = (ids) => {
    return fetch.post(`${prefixUrl}deleteByIds`, ids).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    })
}

const removeByQuery = (keywords) => {
    return fetch.post(`${prefixUrl}deleteByQuery`, keywords).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    })
}

const sendMessage = (keywords) => {
    return fetch.post(`${prefixUrl}sendMessage`, keywords)
    .then(response => {
        return response;
    }).catch(error => {
        Modal.error({
            title: '错误提示',
            content: (
                <div>
                <p>{error.message}</p>
                </div>
            ),
            okText:"确认",
            onOk() {},
        });
    });
}

export default {
    getSelection: () => DataGrid.selections,
    onSelect,
    setRefresh,
    querySearch,
    columns,
    removeByIds,
    removeByQuery,
    sendMessage
}